import React from 'react'
import { bool, node, oneOf, string } from 'prop-types'

import Field from '../../Field'
import VisuallyHidden from '../../VisuallyHidden'

const MultiTextFieldTemplate = ({
  assistance,
  children,
  controlName,
  disabled,
  feedback,
  hideLabel,
  inverse,
  label,
  required,
  status
}) => {
  const MultiTextFieldTemplateQuestion = () => (
    <Field.Question disabled={disabled} noLabel>
      {label}
      {/* {required && <Field.Required />} */}
    </Field.Question>
  )

  return (
    <Field id={`field--${controlName}`} status={status} template="text">
      <fieldset>
        {hideLabel ? (
          <VisuallyHidden>
            <legend>
              <MultiTextFieldTemplateQuestion />
            </legend>
          </VisuallyHidden>
        ) : (
          <legend>
            <MultiTextFieldTemplateQuestion />
          </legend>
        )}
        <Field.Answer>{children}</Field.Answer>
      </fieldset>
      {assistance && <Field.Assistance>{assistance}</Field.Assistance>}
      {feedback && (
        <Field.Feedback inverse={inverse}>{feedback}</Field.Feedback>
      )}
    </Field>
  )
}

MultiTextFieldTemplate.propTypes = {
  assistance: node,
  children: node.isRequired,
  controlName: string,
  disabled: bool,
  feedback: node,
  hideLabel: bool,
  inverse: bool,
  label: node.isRequired,
  required: bool,
  status: oneOf(['error', 'notice', 'success', 'warning'])
}

export default MultiTextFieldTemplate
